/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Alert, Forms, Loader } from '../..';
import { IDataStorage } from '../../../core';
import { FxTranslate } from '../../../core/translate';
import ComprobantePagoComponent, { IComprobantePago } from '../../../pages/admin/reporte/operacion/components/comprobantepago';
import API from '../../../services/api';
import Service from '../../../services/common/services/formservice';
import { CardHelper, ICardEdit } from '../../../services/operaciones/model/ICardEdit';
import { Button, Column, DataTable, Dialog, Panel, SelectButton } from '../../prime';
import { Secciones } from '../index.service';
import styles from './index.module.scss';
import { ISubMedioPago } from '../card-content.component';
import { UsuarioComboItem } from '../../../model/seguridad';
import CnetDropdown from '../../cnet/CnetDropdown';
import { MonedaComboItem } from '../../../model/cobranza/MonedaComboItem';
import { ComprobanteEditIn } from '../../../model/operaciones';
import { OperacionAdjuntoTipo } from '../../../model/operaciones/ComprobanteEditIn';
import { CalcClass } from './pago.seccion.service';
import Security from '../../../services/seguridad';
import { Roles } from '../../../services/api/seguridad/model/IRol';
import { ComboItem } from '../../../model';

const format = (window as any).format;
const round = (n: number) => Math.round(100 * n) / 100;

export type IProps = {
  storage: IDataStorage;
  t: FxTranslate;

  data?: ICardEdit | null | undefined;
  
  monedas?: MonedaComboItem[] | null | undefined;
  submediospago?: ISubMedioPago[] | null | undefined;
  usuarios?: UsuarioComboItem[] | null | undefined;

  onUpdateFields: (updates: { field: string, value: any }[]) => void;
}

let comprobanteForm : Service<IComprobantePago> | undefined = undefined;

function CardSeccionPago({ storage, t,
  data,
  monedas, submediospago, usuarios,
  onUpdateFields,
} : IProps) {
  const onUpdateField = (field: string, value: any) => onUpdateFields([ { field, value }]);
  const [ Calc ] = useState(new CalcClass(onUpdateFields));
  const [ calculatingPrices, setCalculatingPrices ] = useState<boolean>(false);
  const [ comprobanteDialog, setComprobanteDialog ] = useState<{ saving?: boolean } | undefined>(undefined);
  const [ mediospago, setMediosPago ] = useState<ComboItem[]|null>(null);
  const [ recargoCuotasDest, setRecargoCuotasDest] = useState<'cliente' | 'empresa' | undefined>(undefined);

  useEffect(() => {
    const puedeVerTodos = Security.HasOneRolOf([Roles.Admin, Roles.Administracion, Roles.Operador]);
    API.CobranzaController().MedioPago().forCotizador({ 
      idCotizador: puedeVerTodos ? undefined : data?.operacion?.idcotizador,
      idOrigen: puedeVerTodos ? undefined : data?.operacionproducto?.idorigen,
      idProveedor: puedeVerTodos ? undefined : data?.operacionproducto?.idproveedor,
      includeId: data?.operacionpago?.idmediopago, 
      //sistemaOrigen: puedeVerTodos ? undefined : data?.operacion?.sistemaOrigen
      cobroAutomatico: puedeVerTodos ? undefined : false,
    }).then(res => {
      Alert.reponse(res);
      if (res.success && res.data) {
        const data = (res.data ?? []).map(p => ({ id: p.idMedioPago, nombre: p.medioPagoNombre })).sort((a,b) => (a?.nombre ?? '') > (b?.nombre ?? '') ? 1 : -1);
        setMediosPago(data);
      }
    }).catch(ex => Alert.exception(t, ex));
  }, [data?.operacion?.id])
  /*
  */
  useEffect(() => { Calc.setOnUpdateFields(onUpdateFields) }, [onUpdateFields]);
  useEffect(() => {
    if (!!data?.operacionpago?.idmoneda && Calc.IdMoneda !== data?.operacionpago?.idmoneda) 
      Calc.changeMoneda(data?.operacionpago?.idmoneda, t, data);
    if (!!data?.operacion?.idcliente && !!data?.operacionproducto?.idproveedor && (Calc.IdCliente !== data?.operacion?.idcliente || Calc.IdProveedor !== data?.operacionproducto?.idproveedor)) 
      Calc.changeClienteProveedor(data.operacion.idcliente, data.operacionproducto.idproveedor, t);
  }, [data])

  if (!!data?.operacion) {
    data.operacion.totalsaldo = (data?.operacion?.total??0) + (data?.operacionpago?.cuotasrecargo??0) - (data?.operacion?.totaldescuentocomision??0) - (data?.operacion?.totaldescuentovendedor??0) - (data?.operacionpago?.monto??0) + (data?.operacion?.totalajusteredondeo??0);
    data.operacion.totalsaldousd = (data?.operacion?.totalusd??0) + (data?.operacionpago?.cuotasrecargousd??0) - (data?.operacion?.totaldescuentocomisionusd??0) - (data?.operacion?.totaldescuentovendedorusd??0) - (data?.operacionpago?.montousd??0) + (data?.operacion?.totalajusteredondeousd??0);
  }


  const agregarComprobante = (service?: Service<IComprobantePago>) => {
    const dto = service?.getEntity();
    if (!dto?.success || !dto.data) return;
    setComprobanteDialog({ saving: true });
    
    const obj : ComprobanteEditIn = {
      idOperacion: data?.operacion?.id,
      tipo: OperacionAdjuntoTipo.ComprobantePago,
      comentario: dto.data.comentario,
      adjunto: dto.data.adjunto
    };
    (dto.data as any).idoperacion = data?.operacion?.id; // id de operacion
    (dto.data as any).tipo = "CBTE-PAGO";
    API.OperacionesController().Comprobante().insert(obj).then(upd => {
      if (!upd.success) return Alert.reponse(upd);

      Alert.info(t("Seccion.Pago.Dialog.Comprobante.Guardar.Success.Titulo"), t("Seccion.Pago.Dialog.Comprobante.Guardar.Success.Msg"));
      if (data?.operacionadjuntos) 
        data.operacionadjuntos.push({
          id: upd.data,
          creafecha: new Date(),
          creausulogin: Security.User?.login,
          comentarios: obj.comentario,
        } as any);

      onUpdateFields([ { field: `random`, value: Math.random() } ]);
    }).catch(err => Alert.exception(t, err))
    .finally(() => setComprobanteDialog(undefined))
  }
  const removeComprobante = (id: number) => {
    API.OperacionesController().Comprobante().delete({ id })
    .then(res => {
      Alert.reponse(res);
        Alert.info(t("Seccion.Pago.Dialog.Comprobante.Eliminar.Success.Titulo"), t("Seccion.Pago.Dialog.Comprobante.Eliminar.Success.Msg", { id }));
        if (data?.operacionadjuntos)
          data.operacionadjuntos = data.operacionadjuntos.filter(p => p.id !== id);
        onUpdateFields([ { field: `random`, value: Math.random() } ])
      })
    .catch(err => Alert.error(t("Seccion.Pago.Dialog.Comprobante.Eliminar.Error.Titulo"), err))
  }

  const cuotas = {
    destinatario: recargoCuotasDest ?? (((data?.operacionpago?.cuotasrecargo ?? 0) > 0) ? 'cliente' : 'empresa'),
    cuotas: data?.operacionpago?.cuotas,
    field: recargoCuotasDest === 'cliente' ? 'operacionpago.cuotasrecargo' : 'operacionpago.cuotasrecargoempresa',
    porc: recargoCuotasDest === 'cliente' 
      ? ((data?.operacionpago as any)?.cuotasrecargoporc ?? Math.round(100 * 100 * (data?.operacionpago?.cuotasrecargo ?? 0) / (data?.operacion?.total ?? 0)) / 100)
      : ((data?.operacionpago as any)?.cuotasrecargoporc ?? Math.round(100 * 100 * (data?.operacionpago?.cuotasrecargoempresa ?? 0) / (data?.operacion?.total ?? 0)) / 100),
    recargo: recargoCuotasDest === 'cliente' 
      ? data?.operacionpago?.cuotasrecargo
      : data?.operacionpago?.cuotasrecargoempresa,    
    recargousd: recargoCuotasDest === 'cliente' 
      ? data?.operacionpago?.cuotasrecargousd
      : data?.operacionpago?.cuotasrecargoempresausd,
  }
  
  return <div className={styles["card-seccion-content"]}>
    <div className={styles["card-seccion-title"]}>{t(`Menu.${Secciones.Pago}`)}</div>
    
    <div className='p-grid'>
      <div className='p-col-12 p-lg-4 p-p-2'>
        <Forms.Calendar 
          title={t("Seccion.Field.operacionpago.fecha")}
          className={styles["fix-form-component"]}
          disabled={!CardHelper.allowEditCobroField(data, 'operacionpago.fecha')}
          value={!!data?.operacionpago?.fecha ? new Date(data?.operacionpago?.fecha) : undefined} 
          onChange={(v,e) => onUpdateField('operacionpago.fecha', v)}
        />
      </div>
      <div className='p-col-12 p-lg-4 p-p-2'>
        <Loader loading={mediospago === null} >
          {/* MEDIO DE PAGO */}
          <CnetDropdown
            t={t} 
            title={t("Seccion.Field.operacionpago.mediopago")}
            disabled={!CardHelper.allowEditCobroField(data, 'operacionpago.idmediopago')}
            value={data?.operacionpago?.idmediopago}
            optionLabel="nombre" optionValue="id"
            options={mediospago ?? []}
            onChange={e => onUpdateFields([
              { field: 'operacionpago.idmediopago', value: e.value },
              { field: 'operacionpago.idsubmediopago', value: undefined },
            ])}
          />
        </Loader>
      </div>
      <div className='p-col-12 p-lg-4 p-p-2'>
        <CnetDropdown
          t={t}
          title={t("Seccion.Field.operacionpago.idsubmediopago")}
          disabled={!CardHelper.allowEditCobroField(data, 'operacionpago.idsubmediopago')}
          value={data?.operacionpago?.submediopago}
          optionLabel="nombre" optionValue="nombre"
          options={(submediospago ?? []).filter(p => p.idmediopago === data?.operacionpago?.idmediopago)}
          //optionsAsync={(activo) => Promise.resolve({ success: true, data:  })}
          optionsTransform={(data) => [
            ...data.sort((a,b) => (a?.nombre ?? '') > (b?.nombre ?? '') ? 1 : -1)
          ]}
          onChange={e => onUpdateField('operacionpago.submediopago', e.value)}
        />
      </div>
      <div className='p-col-6 p-lg-6 p-p-2'>
        <Forms.InputArea
          title={t("Seccion.Field.operacionpago.referencia")}
          className={styles["fix-form-component"]}
          height={80}
          value={data?.operacionpago?.referencia} 
          onChange={(v,e) => onUpdateField('operacionpago.referencia', v)}
          onlyBlurEvent
        />
      </div>
      <div className='p-col-6 p-lg-6 p-p-2'>
        <Forms.InputArea
          title={t("Seccion.Field.operacionpago.comentarios")}
          className={styles["fix-form-component"]}
          height={80}
          value={data?.operacionpago?.comentarios} 
          onChange={(v,e) => onUpdateField('operacionpago.comentarios', v)}
          onlyBlurEvent
        />
      </div>
      
      {/* IMPORTE PAGADO */}
      <div className={`p-col-12 p-lg-12 p-p-2 ${styles["card-seccion-subtitle"]}`}>
        <Panel header={t(`Menu.${Secciones.Pago}.ImportePagado`)}>
          <div className='p-grid'>
            <div className='p-col-12 p-lg-4 p-p-2'>
              <Loader loading={!monedas || calculatingPrices}>
                <Forms.Dropdown
                  title={t("Seccion.Field.operacionpago.idmoneda")}
                  className={styles["fix-form-component"]}
                  disabled={!CardHelper.allowEditCobroField(data, 'operacionpago.idmoneda')}
                  value={data?.operacionpago?.idmoneda}
                  options={() => (monedas ?? []).map(p => ({ id: p.id, nombre: `${t(p.showKey)} (${p.codigo ?? ' '})` }))} optionLabel="nombre" optionValue="id"
                  onChange={(v,e) => {
                    setCalculatingPrices(true);
                    Calc.changeMoneda(v, t, data).finally(() => setCalculatingPrices(false));
                  }}
                />
              </Loader>
            </div>
            <div className='p-col-12 p-lg-4 p-p-2'>
              <Loader loading={calculatingPrices}>
                <Forms.InputNumber
                  inputId="Board-Card-Seccion-OperacionPago-total"
                  title={t("Seccion.Field.operacionpago.total")}
                  disabled={!CardHelper.allowEditCobroField(data, 'operacionpago.monto')}
                  className={styles["fix-form-component"]}
                  value={data?.operacionpago?.monto} 
                  onChange={(v,e) => !!data && Calc.changePagado(v??0, data, t)}
                />
              </Loader>
            </div>
            <div className='p-col-12 p-lg-4 p-p-2'>
              <Loader loading={calculatingPrices}>
                <Forms.InputNumber
                  icon='fas fa-calculator'
                  inputId="Board-Card-Seccion-OperacionPago-totalusd"
                  title={t("Seccion.Field.operacionpago.totalusd")}
                  className={styles["fix-form-component"]}
                  value={data?.operacionpago?.montousd} 
                  disabled={true}
                />
              </Loader>
            </div>
          </div>
        </Panel>
      </div>

      {/* CUOTAS */}
      <div className={`p-col-12 p-lg-12 p-p-2 ${styles["card-seccion-subtitle"]}`}>
        <Panel 
          header={<>
            {t(`Menu.${Secciones.Pago}.Cuotas`)} <br />
            <SelectButton 
              style={{ marginTop: 5 }}
              optionLabel="name" optionValue='code'
              value={cuotas.destinatario} 
              options={[
                { code: 'cliente', name: t("Seccion.Field.operacionpago.recargocuotas.cliente") },
                { code: 'empresa', name: t("Seccion.Field.operacionpago.recargocuotas.empresa") },
              ]}
              onChange={(e) => setRecargoCuotasDest(e.value)}
            />
          </>}
        >
          <div className='p-grid'>
            <div className='p-col-12 p-lg-3 p-p-2'>
              <Forms.InputNumber
                inputId="Board-Card-Seccion-OperacionPago-cuotas"
                title={t("Seccion.Field.operacionpago.cuotas")}
                className={styles["fix-form-component"]}
                disabled={!CardHelper.allowEditCobroField(data, 'operacionpago.cuotas')}
                value={cuotas.cuotas} 
                onChange={(v,e) => {
                  onUpdateFields([{ field: `operacionpago.cuotas`, value: v }])
                }}
              />
            </div>
            <div className='p-col-12 p-lg-3 p-p-2'>
              <Loader loading={calculatingPrices}>
                <Forms.InputNumber
                  inputId="Board-Card-Seccion-OperacionPago-cuotasrecargoporc"
                  title={t("Seccion.Field.operacionpago.cuotasrecargoporc")}
                  className={styles["fix-form-component"]}
                  disabled={!CardHelper.allowEditCobroField(data, 'operacionpago.cuotasrecargoporc')}
                  value={cuotas.porc} 
                  onChange={(v,e) => !!data && Calc.changeCuotasRecargo(v??0, cuotas.field, undefined, data, t)}
                />
              </Loader>
            </div>
            <div className='p-col-12 p-lg-3 p-p-2'>
              <Loader loading={calculatingPrices}>
                <Forms.InputNumber
                  inputId="Board-Card-Seccion-OperacionPago-cuotasrecargo"
                  title={t("Seccion.Field.operacionpago.cuotasrecargo")}
                  disabled={!CardHelper.allowEditCobroField(data, 'operacionpago.cuotasrecargo')}
                  className={styles["fix-form-component"]}
                  value={cuotas.recargo} 
                  onChange={(v,e) => !!data && Calc.changeCuotasRecargo(undefined, cuotas.field, v??0, data, t)}
                />
              </Loader>
            </div>
            <div className='p-col-12 p-lg-3 p-p-2'>
              <Loader loading={calculatingPrices}>
                <Forms.InputNumber
                  icon='fas fa-calculator'
                  inputId="Board-Card-Seccion-OperacionPago-cuotasrecargousd"
                  title={t("Seccion.Field.operacionpago.cuotasrecargousd")}
                  className={styles["fix-form-component"]}
                  value={data?.operacionpago?.cuotasrecargousd} 
                  disabled={true}
                />
              </Loader>
            </div>
          </div>
        </Panel>        
      </div>


      {/* DESCUENTO COMISON */}
      { !Security.HasOneRolOf([Roles.Vendedor, Roles.Supervisor]) && (data?.operacion?.esprecioneto ?? false) === false &&
        <div className={`p-col-12 p-lg-12 p-p-2 ${styles["card-seccion-subtitle"]}`}>
          <Panel header={t(`Menu.${Secciones.Pago}.DescuentoComision`)}>
            <div className='p-grid'>
              <div className='p-col-4 p-lg-4 p-p-2'>
                <Loader loading={calculatingPrices}>
                  <Forms.InputNumber
                    inputId="Board-Card-Seccion-OperacionPago-descuentocomisionporc"
                    title={t("Seccion.Field.operacionpago.descuentocomisionporc")}
                    className={styles["fix-form-component"]}
                    disabled={!CardHelper.allowEditCobroField(data, 'operacionpago.descuentocomisionporc')}
                    value={(data?.operacion as any)?.totaldescuentocomisionporc ?? Math.round(100 * 100 * (data?.operacion?.totaldescuentocomision ?? 0) / (data?.operacion?.total ?? 0)) / 100}
                    onChange={(v,e) => !!data && Calc.changeComision(v??0, undefined, data, t)}
                  />
                </Loader>
              </div>
              <div className='p-col-4 p-lg-4 p-p-2'>
                <Loader loading={calculatingPrices}>
                  <Forms.InputNumber
                    inputId="Board-Card-Seccion-OperacionPago-descuentocomision"
                    title={t("Seccion.Field.operacionpago.descuentocomision")}
                    className={styles["fix-form-component"]}
                    disabled={!CardHelper.allowEditCobroField(data, 'operacionpago.totaldescuentocomision')}
                    value={data?.operacion?.totaldescuentocomision} 
                    onChange={(v,e) => !!data && Calc.changeComision(undefined, v??0, data, t)}
                  />
                </Loader>
              </div>
              <div className='p-col-4 p-lg-4 p-p-2'>
                <Loader loading={calculatingPrices}>
                  <Forms.InputNumber
                    icon='fas fa-calculator'
                    inputId="Board-Card-Seccion-OperacionPago-descuentocomisionusd"
                    title={t("Seccion.Field.operacionpago.descuentocomisionusd")}
                    className={styles["fix-form-component"]}
                    value={data?.operacion?.totaldescuentocomisionusd} 
                    disabled={true}
                  />
                </Loader>
              </div>
            </div>
          </Panel>
        </div>
      }


      {/* DESCUENTO VENDEDOR */}
      {!Security.HasOneRolOf([Roles.Agente, Roles.Counter, Roles.EjecutivoCuenta]) &&
        <div className={`p-col-12 p-lg-12 p-p-2 ${styles["card-seccion-subtitle"]}`}>
          <Panel header={t(`Menu.${Secciones.Pago}.DescuentoVendedor`)}>
            <div className='p-grid'>
              <div className='p-col-4 p-lg-4 p-p-2'>
                <Loader loading={calculatingPrices}>
                  <Forms.InputNumber
                    inputId="Board-Card-Seccion-OperacionPago-descuentovendedorporc"
                    title={t("Seccion.Field.operacionpago.descuentovendedorporc")}
                    className={styles["fix-form-component"]}
                    disabled={!CardHelper.allowEditCobroField(data, 'operacionpago.totaldescuentovendedorporc')}
                    value={(data?.operacion as any)?.totaldescuentovendedorporc ?? Math.round(100 * 100 * (data?.operacion?.totaldescuentovendedor ?? 0) / (data?.operacion?.total ?? 0)) / 100} 
                    onChange={(v,e) => !!data && Calc.changeDescuentoVendedor(v??0, undefined, data, t)}
                  />
                </Loader>
              </div>
              <div className='p-col-4 p-lg-4 p-p-2'>
                <Loader loading={calculatingPrices}>
                  <Forms.InputNumber
                    inputId="Board-Card-Seccion-OperacionPago-descuentovendedor"
                    title={t("Seccion.Field.operacionpago.descuentovendedor")}
                    className={styles["fix-form-component"]}
                    disabled={!CardHelper.allowEditCobroField(data, 'operacionpago.totaldescuentovendedor')}
                    value={data?.operacion?.totaldescuentovendedor} 
                    onChange={(v,e) => !!data && Calc.changeDescuentoVendedor(undefined, v??0, data, t)}
                  />
                </Loader>
              </div>
              <div className='p-col-4 p-lg-4 p-p-2'>
                <Loader loading={calculatingPrices}>
                  <Forms.InputNumber
                    icon='fas fa-calculator'
                    inputId="Board-Card-Seccion-OperacionPago-descuentovendedorusd"
                    title={t("Seccion.Field.operacionpago.descuentovendedorusd")}
                    className={styles["fix-form-component"]}
                    value={data?.operacion?.totaldescuentovendedorusd} 
                    disabled={true}
                  />
                </Loader>
              </div>
            </div>
          </Panel>
        </div>
      }

      {/* REDONDEO */}
      <div className={`p-col-12 p-lg-12 p-p-2 ${styles["card-seccion-subtitle"]}`}>
        <Panel header={t(`Menu.${Secciones.Pago}.Redondeo`)}>
          <div className='p-grid'>
            <div className='p-col-6 p-lg-6 p-p-2'>
              <Loader loading={calculatingPrices}>
                <Forms.InputNumber
                  inputId="Board-Card-Seccion-OperacionPago-ajusteredondeo"
                  title={t("Seccion.Field.operacionpago.ajusteredondeo")}
                  className={styles["fix-form-component"]}
                  disabled={!CardHelper.allowEditCobroField(data, 'operacionpago.totalajusteredondeo')}
                  value={data?.operacion?.totalajusteredondeo} 
                  min={(data?.operacion?.total ?? 0) * -0.1}
                  max={(data?.operacion?.total ?? 0) * 0.1}
                  onChange={(v,e) => !!data && Calc.changeRedondeo(v??0, data, t)}
                />
              </Loader>
            </div>
            <div className='p-col-6 p-lg-6 p-p-2'>
              <Loader loading={calculatingPrices}>
                <Forms.InputNumber
                  icon='fas fa-calculator'
                  inputId="Board-Card-Seccion-OperacionPago-ajusteredondeousd"
                  title={t("Seccion.Field.operacionpago.ajusteredondeousd")}
                  className={styles["fix-form-component"]}
                  disabled={!CardHelper.allowEditCobroField(data, 'operacionpago.totalajusteredondeousd')}
                  value={data?.operacion?.totalajusteredondeousd} 
                  onChange={(v,e) => !!data && Calc.changeRedondeoUsd(v??0, data, t)}
                >
                  <Button 
                    type="button" icon="fab fa-creative-commons-zero" 
                    tooltip={t("Seccion.Field.operacionpago.ajusteredondeousd.Round.Tooltip")} tooltipOptions={{ position: 'top' }} 
                    disabled={!CardHelper.allowEditCobroField(data, 'operacionpago.totalajusteredondeousd')}  // mismos permisos que el campo de ajuste de redondeo usd
                    onClick={() => !!data && Calc.changeRedondeoUsd(-1 * ((data?.operacion?.totalsaldousd ?? 0) - (data?.operacion?.totalajusteredondeousd ?? 0)), data, t)}
                  />
                </Forms.InputNumber>
              </Loader>
            </div>
          </div>
        </Panel>
      </div>
      
      <ResumenGrid data={data} monedas={monedas} t={t} />
      
      {/* COMPROBANTES */}
      <div className='p-col-12 p-lg-12 p-p-2'>
        <div className='hseparator' />
        <div className='hseparator' />
        <h4>{t("Seccion.Pago.SubSeccion.Comprobantes")}</h4>
        <div className='hseparator' />
        <Button icon="fas fa-plus" className='p-button-success p-button-sm p-button-outlined' label={t("Btn.Pago.Comprobantes.New")} onClick={() => setComprobanteDialog({})} style={{ marginBottom: 8 }} />
        <div className="datatable-responsive-demo">
          <DataTable 
            value={data?.operacionadjuntos?.filter(p => p.tipo === 1 && !p.bajafecha) ?? []}
            className="p-datatable-responsive-demo"
          >
            <Column 
              field='creafecha' 
              header={t("Seccion.Field.operacionadjuntos.creafecha")} 
              style={{ textAlign: 'center' }} 
              body={(row,col) => <>{format(row.creafecha, "dd/MM/yyyy HH:mm")}</>}
            />
            <Column 
              field='creausulogin' 
              header={t("Seccion.Field.operacionadjuntos.creausulogin")} 
              style={{ textAlign: 'center' }}
              body={row => <>{(usuarios??[]).find(u => u.id === row.creausu)?.login}</>}
            />
            <Column field='comentarios' header={t("Seccion.Field.operacionadjuntos.comentario")} />
            <Column 
              style={{ width: 90, textAlign: 'center' }} 
              body={(row,col) => <div style={{ whiteSpace: 'nowrap' }}>
                <Button 
                  icon='pi pi-download' 
                  className='p-button-rounded p-button-outlined p-button-sm'
                  style={{ width: 28, height: 28, padding: 0 }}
                  onClick={() => window.open(row.archivourl)}
                />
                <Button 
                  icon='pi pi-trash' 
                  className='p-button-rounded p-button-danger p-button-outlined p-button-sm'
                  style={{ width: 28, height: 28, padding: 0, marginLeft: 7 }}
                  onClick={() => removeComprobante(row.id)}
                />
              </div>}
            />
          </DataTable>
        </div>
        <Dialog 
          visible={!!comprobanteDialog} 
          onHide={() => setComprobanteDialog(undefined)} 
          header={t("Seccion.Pago.Dialog.Comprobante.Titulo")} 
          style={{ width: 800, maxWidth: '100%' }} 
          footer={<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
            <Loader loading={!!comprobanteDialog?.saving}>
              <Button icon="pi pi-times" label={t("Seccion.Pago.Dialog.Comprobante.Cerrar")} className="p-button-secondary" onClick={() => setComprobanteDialog(undefined)} tooltip={t("Seccion.Pago.Dialog.Comprobante.Cerrar.Tooltip")} tooltipOptions={{ position: 'top' }} style={{ marginLeft: 10 }} />
              <Button icon="pi pi-save" label={t("Seccion.Pago.Dialog.Comprobante.Agregar")} className="p-button-primary" tooltip={t("Seccion.Pago.Dialog.Comprobante.Agregar.Tooltip")} tooltipOptions={{ position: 'top' }} onClick={() => agregarComprobante(comprobanteForm)} />
            </Loader>
          </div>}
        >
          <Loader loading={!!comprobanteDialog?.saving}>
            <ComprobantePagoComponent id={undefined} refService={e => comprobanteForm = e} />
          </Loader>
        </Dialog>
      </div>
      
    </div>
  </div>;
}
export default connect((s:any) => ({ storage:s.main }))(CardSeccionPago);


function ResumenGrid({ data, monedas, t } : {
  data?: ICardEdit | null | undefined;
  monedas?: MonedaComboItem[] | null | undefined;
  t: FxTranslate;
}) {

  const idmoneda = data?.operacionpago?.idmoneda;

  const rows = [{
    moneda: `${t(monedas?.find(p => p.id === idmoneda)?.showKey)} (${monedas?.find(p => p.id === idmoneda)?.codigo})`,
    tc: format(data?.operacion?.monedacotizacion, '$$'),
    total: format(data?.operacion?.total, '$$'),
    cuotasrecargo: format(data?.operacionpago?.cuotasrecargo, '$$'),
    comision: format(data?.operacion?.totaldescuentocomision, '$$'),
    vendedor: format(data?.operacion?.totaldescuentovendedor, '$$'),
    apagar: format(round((data?.operacion?.total??0) + (data?.operacionpago?.cuotasrecargo??0) - (data?.operacion?.totaldescuentocomision??0) - (data?.operacion?.totaldescuentovendedor??0)), '$$'),
    pago: format(data?.operacionpago?.monto, '$$'),
    redondeo: format(data?.operacion?.totalajusteredondeo, '$$'),
    saldo: format(round((data?.operacion?.total??0) + (data?.operacionpago?.cuotasrecargo??0) - (data?.operacion?.totaldescuentocomision??0) - (data?.operacion?.totaldescuentovendedor??0)
            - (data?.operacionpago?.monto??0) + (data?.operacion?.totalajusteredondeo??0)), '$$'),
  },{
    moneda: `${t(monedas?.find(p => p.codigo === 'USD')?.showKey)} (${monedas?.find(p => p.codigo === 'USD')?.codigo})`,
    tc: 1,
    total: format(data?.operacion?.totalusd, '$$'),
    cuotasrecargo: format(data?.operacionpago?.cuotasrecargousd, '$$'),
    comision: format(data?.operacion?.totaldescuentocomisionusd, '$$'),
    vendedor: format(data?.operacion?.totaldescuentovendedorusd, '$$'),
    apagar: format(round((data?.operacion?.totalusd??0) + (data?.operacionpago?.cuotasrecargousd??0) - (data?.operacion?.totaldescuentocomisionusd??0) - (data?.operacion?.totaldescuentovendedorusd??0)), '$$'),
    pago: format(data?.operacionpago?.montousd, '$$'),
    redondeo: format(data?.operacion?.totalajusteredondeousd, '$$'),
    saldo: format(round((data?.operacion?.totalusd??0) + (data?.operacionpago?.cuotasrecargousd??0) - (data?.operacion?.totaldescuentocomisionusd??0) - (data?.operacion?.totaldescuentovendedorusd??0) 
            - (data?.operacionpago?.montousd??0) + (data?.operacion?.totalajusteredondeousd??0)), '$$'),
  }];

  return <>
    <div className='p-col-12 p-lg-12 p-p-2'>
      <div className="datatable-responsive-demo">
        <DataTable 
          value={rows}
          className="p-datatable-responsive-demo"
        >
          <Column field='moneda' header={t("Seccion.Field.operacionpago.moneda")} />
          <Column field='tc' header={t("Seccion.Field.operacionpago.tc")} style={{ textAlign: 'right' }} />
          <Column field='total' header={t("Seccion.Field.operacion.total")} style={{ textAlign: 'right' }} />
          <Column field='cuotasrecargo' header={t("Seccion.Field.operacionpago.cuotasrecargo")} style={{ textAlign: 'right' }} />
          {
            (data?.operacion?.esprecioneto ?? false) === false &&
            <Column field='comision' header={t("Seccion.Field.operacionpago.descuentocomision")} style={{ textAlign: 'right' }} />
          }
          <Column field='vendedor' header={t("Seccion.Field.operacionpago.descuentovendedor")} style={{ textAlign: 'right' }} />
          <Column field='apagar' header={t("Seccion.Field.operacionpago.apagar")} style={{ textAlign: 'right' }} />
          <Column field='pago' header={t("Seccion.Field.operacionpago.monto")} style={{ textAlign: 'right' }} />
          <Column field='redondeo' header={t("Seccion.Field.operacionpago.ajusteredondeo")} style={{ textAlign: 'right' }} />
          <Column field='saldo' header={t("Seccion.Field.operacion.saldo")} style={{ textAlign: 'right' }} />
        </DataTable>
      </div>
    </div>
  </>;
}